import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RealProperty } from '@eemo/api-client';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeoLocationHelper {
  constructor(private httpClient: HttpClient) {}

  /**
   * Return the location from the property address
   * @return observale with an array with lat and lon properties (data[0].lat, data[0].lon for the first result)
   * https://nominatim.org/release-docs/develop/api/Search/
   */
  findLocationFromPropertyAddress(prop: RealProperty): Observable<any> {
    if (prop.address && prop.address.street && prop.address.postalCode && prop.address.city) {
      const country = prop.address.country ? prop.address.country : 'France';
      const headers = new HttpHeaders().append('Accept', 'application/json');
      const params = new HttpParams()
        .append('street', prop.address.street)
        .append('city', prop.address.city)
        .append('postalcode', prop.address.postalCode)
        .append('country', country)
        .append('format', 'json');

      return this.httpClient.get('https://nominatim.openstreetmap.org/search', { headers, params });
    }
  }

  /**
   * Return the location from a free style address
   * @return observale with an array with lat and lon properties (data[0].lat, data[0].lon for the first result)
   * https://nominatim.org/release-docs/develop/api/Search/
   */
  findLocationFromAddress(address: string): Observable<any> {
    if (address) {
      const headers = new HttpHeaders().append('Accept', 'application/json');
      const params = new HttpParams().append('q', address).append('format', 'json');

      return this.httpClient.get('https://nominatim.openstreetmap.org/search', { headers, params });
    }
  }

  /**
   * Find the insee code from the property address
   * observale with an array with code property (data[0].code for the first result)
   */
  findCodeInseeFromPropertyAddress(prop: RealProperty): Observable<any> {
    if (prop.address && prop.address.postalCode && prop.address.city) {
      const country = prop.address.country ? prop.address.country : 'France';
      const headers = new HttpHeaders().append('Accept', 'application/json');
      const params = new HttpParams().append('nom', prop.address.city).append('codePostal', prop.address.postalCode);

      return this.httpClient.get('https://geo.api.gouv.fr/communes', { headers, params });
    }
  }
}
